import { useCallback } from 'react';
import { useQuery } from '@apollo/client';

import { GET_ID } from '../../../../../../graphql/profile/queries';
import { isYMEnabled, pushMyAcuvueId } from '../../../../../../utils';

export const useIdAnalytics = (): { pushId: () => void } => {
  const { data } = useQuery(GET_ID, { fetchPolicy: 'network-only' });

  const pushId = useCallback(() => {
    if (data) {
      if (isYMEnabled() && !!localStorage.getItem('isMyAcuvueId') && data.profile?.myAcuvueId) {
        pushMyAcuvueId(data.profile?.myAcuvueId);
        localStorage.removeItem('myAcuvueId');
      }
    }
  }, [data]);

  return { pushId };
};
